export default "__VITE_ASSET__o0ir79Eh__"